var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Button from '../button';
import { ConfigConsumer } from '../config-provider';
import Dropdown from './dropdown';
import classNames from 'classnames';
import { tuple } from '../_util/type';
const ButtonGroup = Button.Group;
// type DropdownButtonType = 'primary' | 'ghost' | 'dashed' | 'default';
const ButtonTypes = tuple('default', 'primary', 'ghost', 'dashed', 'link', 'success', 'warning', 'danger', 'popup-cancel', 'popup-sure', 'greyfull', 'wxorange', 'wxblue');
export default class DropdownButton extends React.Component {
    constructor() {
        // static defaultProps = {
        //   placement: 'bottomRight' as DropDownProps['placement'],
        //   type: 'default' as DropdownButtonType,
        // };
        super(...arguments);
        this.renderButton = ({ getPopupContainer: getContextPopupContainer, getPrefixCls, }) => {
            const _a = this.props, { prefixCls: customizePrefixCls, type, disabled, onClick, htmlType, children, className, overlay, trigger, align, visible, onVisibleChange, placement, getPopupContainer, href } = _a, restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href"]);
            const prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
            const dropdownProps = {
                align,
                overlay,
                disabled,
                trigger: disabled ? [] : trigger,
                onVisibleChange,
                placement,
                getPopupContainer: getPopupContainer || getContextPopupContainer,
            };
            if ('visible' in this.props) {
                dropdownProps.visible = visible;
            }
            return (<ButtonGroup {...restProps} className={classNames(prefixCls, className)}>
        <Button type={type} disabled={disabled} onClick={onClick} htmlType={htmlType} href={href}>
          {children}
        </Button>
        <Dropdown {...dropdownProps}>
          <Button type={type} icon="ellipsis"/>
        </Dropdown>
      </ButtonGroup>);
        };
    }
    render() {
        return <ConfigConsumer>{this.renderButton}</ConfigConsumer>;
    }
}
